import { GetterTree } from 'vuex'
import { AccountsState } from './types';
import { RootState } from '@/store/types';
import { SelectItem } from '@/store/types';

export const getters: GetterTree<AccountsState, RootState> = {
  accounts:state => state.accounts,
  accountItem:state => state.accountItem,
  protocolList:state => state.protocolList
};